import styled from 'styled-components';

export const ScrollBoxModule = styled.div`
    padding: 30px;
    border: 1px solid #e2e2e2;
    border-radius: 5px;
    height: 360px;
    overflow-y: scroll;
`;